// Fetch list

export const FETCH = 'driverTimes.FETCH'
export const FETCH_STARTED = 'driverTimes.FETCH_STARTED'
export const FETCH_FULFILLED = 'driverTimes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'driverTimes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'driverTimes.FETCH_CANCELLED'
